
document.addEventListener("DOMContentLoaded", function () {

  const board = document.getElementById("volitaire-board");
  if (!board) return;

  const RANKS = ["01","02","03","04","05","06","07","08","09","10","11","12","13"];
  const FOOLS = ["53","54","55","56"];

  // Your Shopify Files CDN base:
  const BASE_URL = "https://cdn.shopify.com/s/files/1/0934/5859/6209/files/";

  // ---------- STATE ----------
  let deck = [];
  let drawCount = 1; // default (Volitaire)
    if (window.location.pathname.includes("-3")) {
     drawCount = 3;
    }

  let gameState = "gameplay";

  // gameplay state
  let state = {
    tableau: [[],[],[],[],[],[],[]],
    stock: [],
    waste: [],
    foundations: {
      hearts: [],
      diamonds: [],
      clubs: [],
      spades: []
    },
    selected: null // { from: "tableau"|"waste", col, index } OR null
  };

  // ---------- INIT ----------
  buildDeckFactoryOrder();
  const foolAssignments = castFools();
  applyFoolAssignments(foolAssignments);
  startGameplay();
  render();

function renderPreserveScroll() {
  const scroller = board.querySelector("#scroll-container");
  const scrollLeft = scroller ? scroller.scrollLeft : 0;

  render();

  const newScroller = board.querySelector("#scroll-container");
  if (newScroller) {
    newScroller.scrollLeft = scrollLeft;
  }
}


// One event listener for everything (delegation)
  board.addEventListener("click", (e) => {
    const el = e.target.closest("[data-action]");
    if (!el) return;

    const action = el.dataset.action;

    // ---------- FACTORY / CASTING ----------
    if (action === "castRoles") {
      gameState = "casting";
      renderPreserveScroll();
      return;
    }

    if (action === "beginPlay") {
      gameState = "gameplay";
      startGameplay();
      renderPreserveScroll();
      return;
    }

    // ---------- GAMEPLAY ----------
    if (gameState !== "gameplay") return;

    if (action === "drawStock") {
      drawFromStock();
      renderPreserveScroll();
      return;
    }

    if (action === "recycleStock") {
      recycleWasteToStock();
      renderPreserveScroll();
      return;
    }

    if (action === "selectWaste") {
      toggleSelectWasteTop();
      renderPreserveScroll();
      return;
    }

    if (action === "selectTableau") {
    const col = parseInt(el.dataset.col, 10);
    const idx = parseInt(el.dataset.idx, 10);

    // If something is already selected, treat clicking another tableau card as a MOVE attempt.
    const sel = state.selected;
    if (sel && !(sel.from === "tableau" && sel.col === col && sel.index === idx)) {
        attemptMoveToTableau(col);
    } else {
        // Otherwise normal select/deselect
        toggleSelectTableau(col, idx);
    }

    renderPreserveScroll();
    return;
    }

    if (action === "targetTableau") {
      const col = parseInt(el.dataset.col, 10);
      attemptMoveToTableau(col);
      renderPreserveScroll();
      return;
    }

    if (action === "targetFoundation") {
      const suit = el.dataset.suit;
      attemptMoveToFoundation(suit);
      renderPreserveScroll();
      return;
    }
  });

  // ---------- CORE HELPERS ----------
  function shuffleDeck(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function isRedSuit(suit) {
    return suit === "hearts" || suit === "diamonds";
  }

  function cardColor(card) {
    return isRedSuit(card.suit) ? "red" : "black";
  }

  // Volitaire effective rank:
  // Standard ranks:
  // 01-10 => 1-10
  // 11(Jack) => 12
  // 12(Queen) => 13
  // 13(King) => 14
  // Fool => 11
  function rankValue(card) {
    if (card.type === "fool") return 11;

    const n = parseInt(card.rank, 10);
    if (n <= 10) return n;
    if (n === 11) return 12; // Jack
    if (n === 12) return 13; // Queen
    if (n === 13) return 14; // King
    return n;
  }

  function top(arr) {
    return arr.length ? arr[arr.length - 1] : null;
  }

  function clearSelection() {
    state.selected = null;
  }

  // ---------- DECK + CASTING ----------
  function castFools() {
    const suits = ["hearts","diamonds","clubs","spades"];
    const shuffledSuits = shuffleDeck([...suits]);

    const mapping = {};
    FOOLS.forEach((id, i) => {
      mapping[id] = { suit: shuffledSuits[i], rank: "11" };
    });

    console.log("Fool Assignments:", mapping);
    return mapping;
  }

  function applyFoolAssignments(assignments) {
    deck.forEach(card => {
      if (card.type === "fool") {
        card.suit = assignments[card.id].suit;
        card.rank = assignments[card.id].rank; // "11"
      }
    });
  }

  // Factory order:
  // Spades A->K, Diamonds A->K, Clubs K->A, Hearts K->A, then extras 53-56
  function buildDeckFactoryOrder() {
    deck = [];

    const asc = [...RANKS];
    const desc = [...RANKS].reverse();

    asc.forEach(rank => deck.push({ type:"standard", suit:"spades", rank }));
    asc.forEach(rank => deck.push({ type:"standard", suit:"diamonds", rank }));
    desc.forEach(rank => deck.push({ type:"standard", suit:"clubs", rank }));
    desc.forEach(rank => deck.push({ type:"standard", suit:"hearts", rank }));

    FOOLS.forEach(id => deck.push({ type:"fool", id }));
  }

  // ---------- START GAMEPLAY ----------
  function startGameplay() {
    // reset state
    state = {
      tableau: [[],[],[],[],[],[],[]],
      stock: [],
      waste: [],
      foundations: { hearts: [], diamonds: [], clubs: [], spades: [] },
      selected: null
    };

    // shuffle full deck for play
    shuffleDeck(deck);

    // deal tableau (7 columns)
    let di = 0;
    for (let col = 0; col < 7; col++) {
      for (let row = 0; row <= col; row++) {
        state.tableau[col].push({
          ...deck[di],
          faceUp: row === col,
          rotation: Math.random() > 0.5 ? 180 : 0
        });
        di++;
      }
    }

    // remaining cards to stock
    state.stock = deck.slice(di).map(c => ({
      ...c,
      faceUp: false,
      rotation: Math.random() > 0.5 ? 180 : 0
    }));
  }

  // ---------- STOCK / WASTE ----------
function drawFromStock() {
  clearSelection();

  if (state.stock.length === 0) {
    if (state.waste.length > 0) {
      recycleWasteToStock();
    }
    return;
  }

  const draws = Math.min(drawCount, state.stock.length);

  for (let i = 0; i < draws; i++) {
    const card = state.stock.pop();
    card.faceUp = true;
    state.waste.push(card);
  }
}

  function recycleWasteToStock() {
    clearSelection();

    if (state.stock.length > 0) return;
    if (state.waste.length === 0) return;

    // recycle waste back into stock (face down)
    // standard: reverse order so last waste becomes first stock
    const recycled = state.waste.reverse().map(c => ({
      ...c,
      faceUp: false
    }));
    state.stock = recycled;
    state.waste = [];
  }

  // ---------- SELECTION ----------
  function toggleSelectWasteTop() {
    if (state.waste.length === 0) return;

    const sel = state.selected;
    if (sel && sel.from === "waste") {
      clearSelection();
      return;
    }
    state.selected = { from: "waste" };
  }

  function toggleSelectTableau(col, idx) {
    const column = state.tableau[col];
    const card = column[idx];
    if (!card || !card.faceUp) return;

    const sel = state.selected;
    if (sel && sel.from === "tableau" && sel.col === col && sel.index === idx) {
      clearSelection();
      return;
    }

    state.selected = { from: "tableau", col, index: idx };
  }

  function getSelectedStack() {
    const sel = state.selected;
    if (!sel) return null;

    if (sel.from === "waste") {
      const c = top(state.waste);
      if (!c) return null;
      return { cards: [c], source: "waste" };
    }

    if (sel.from === "tableau") {
      const column = state.tableau[sel.col];
      const stack = column.slice(sel.index);
      return { cards: stack, source: "tableau", col: sel.col, index: sel.index };
    }

    return null;
  }

  // ---------- MOVES ----------
  function attemptMoveToTableau(targetCol) {
    const selStack = getSelectedStack();
    if (!selStack) return;

    const movingCards = selStack.cards;
    const movingTop = movingCards[0];

    const targetColumn = state.tableau[targetCol];
    const targetTop = top(targetColumn);

    // Empty column: only allow King (effective 14)
    if (!targetTop) {
      if (rankValue(movingTop) !== 14) return;
      commitMoveToTableau(selStack, targetCol);
      return;
    }

    // Must place on face-up top card
    if (!targetTop.faceUp) return;

    // Standard rule: descending by 1, alternating color
    const okRank = rankValue(movingTop) === rankValue(targetTop) - 1;
    const okColor = cardColor(movingTop) !== cardColor(targetTop);

    if (!okRank || !okColor) return;

    commitMoveToTableau(selStack, targetCol);
  }

  function commitMoveToTableau(selStack, targetCol) {
    // remove from source
    if (selStack.source === "waste") {
      state.waste.pop();
    } else {
      state.tableau[selStack.col] = state.tableau[selStack.col].slice(0, selStack.index);
    }

    // add to target
    state.tableau[targetCol] = state.tableau[targetCol].concat(selStack.cards);

    // flip exposed card (if any)
    if (selStack.source === "tableau") {
      const srcCol = selStack.col;
      const srcTop = top(state.tableau[srcCol]);
      if (srcTop && !srcTop.faceUp) srcTop.faceUp = true;
    }

    clearSelection();
  }

  function attemptMoveToFoundation(suit) {
    const selStack = getSelectedStack();
    if (!selStack) return;

    // Only single-card moves to foundation
    if (selStack.cards.length !== 1) return;

    const card = selStack.cards[0];

    // Must match foundation suit
    if (card.suit !== suit) return;

    const pile = state.foundations[suit];
    const pileTop = top(pile);

    // Expected rank:
    // start with Ace (1), then +1
    const expected = pileTop ? rankValue(pileTop) + 1 : 1;

    if (rankValue(card) !== expected) return;

    // commit
    if (selStack.source === "waste") {
      state.waste.pop();
    } else {
      state.tableau[selStack.col] = state.tableau[selStack.col].slice(0, selStack.index);
      const srcTop = top(state.tableau[selStack.col]);
      if (srcTop && !srcTop.faceUp) srcTop.faceUp = true;
    }

    pile.push(card);

    clearSelection();
  }

  // ---------- RENDER ----------
  function render() {
    console.log("Deck ready", deck);
    if (gameState === "factory") return renderFactoryView();
    if (gameState === "casting") return renderCastingView();
    if (gameState === "gameplay") return renderGameplayView();
  }

  function renderFactoryView() {
    console.log("renderFactoryView called, deck length:", deck.length);
    board.innerHTML = `
      <div style="display:grid; grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)); gap:10px; margin-bottom:40px;">
        ${deck.map(card => renderCardThumb(card)).join("")}
      </div>

      <div style="text-align:center;">
        <button data-action="castRoles" style="padding:12px 24px; font-size:16px; cursor:pointer;">
          Prepare to Play
        </button>
      </div>
    `;
  }

  function renderCastingView() {
    const suitEmoji = { hearts:"♥️", diamonds:"♦️", clubs:"♣️", spades:"♠️" };
    const fools = deck.filter(c => c.type === "fool");

    board.innerHTML = `
      <div style="text-align:left; margin-bottom:10px;">
        <h2>Þe rare face cards are now assigned.</h2>
        <h3>Each card has been assigned to a suit.</h3>
      </div>

      <div style="display:flex; flex-wrap:wrap; justify-content:center; gap:40px; margin-bottom:40px;">
        ${fools.map(card => renderCastingCard(card, suitEmoji)).join("")}
      </div>

      <div style="text-align:center;">
        <button data-action="beginPlay" style="padding:12px 24px; font-size:16px; cursor:pointer;">
          You may Begin
        </button>
      </div>
    `;
  }

  function renderGameplayView() {
  const suitEmoji = {
    hearts: "♥️",
    diamonds: "♦️",
    clubs: "♣️",
    spades: "♠️"
  };
  const fools = deck.filter(c => c.type === "fool");

  board.innerHTML = `
    <div id="scroll-container" style="overflow-x:auto; width:100%;">
      <div style="min-width:1012px;">

        <!-- Face cards and Foundations -->
        <div style="
          display:flex;
          justify-content:flex-start;
          align-items:flex-start;
          gap:80px;
          margin-bottom:18px;
        ">
          <div style="display:flex; gap:8px;">
            ${fools.map(card => `
              <div style="width:70px; text-align:center;">
                <div style="
                  height:36px;
                  line-height:36px;
                  font-size:30px;
                  margin-bottom:6px;
                ">
                  <span class="suit-circle">${suitEmoji[card.suit]}</span>
                </div>
                <img
                  src="${BASE_URL}200x280_extra_${card.id}.png"
                  alt="Special face card ${card.id}, assigned to ${card.suit}"
                  style="display:block; width:70px; height:98px;"
                />
              </div>
            `).join("")}
          </div>

          <div style="display:flex; gap:8px;">
            ${["spades", "hearts", "diamonds", "clubs"].map(suit => `
              <div style="width:70px; text-align:center;">
                <div style="
                  height:36px;
                  line-height:36px;
                  font-size:30px;
                  margin-bottom:6px;
                ">
                  <span class="suit-circle">${suitEmoji[suit]}</span>
                </div>
                ${renderFoundation(suit)}
              </div>
            `).join("")}
          </div>
        </div>

        <!-- Stock, Waste, and Tableau -->
        <div style="
          display:flex;
          align-items:flex-start;
          justify-content:flex-start;
          Gap: 8px;
        ">
          <div style="width:100px; flex:0 0 100px; text-align:center;">
            <div style="
              height:20px;
              line-height:20px;
              margin-bottom:6px;
              font-size:14px;
            ">Stock</div>
            ${renderStock()}
            <div style="margin-top:8px;">
              <button
                data-action="recycleStock"
                style="padding:6px 10px; font-size:12px; cursor:pointer;"
              >Recycle</button>
            </div>
          </div>

          <div style="width:100px; flex:0 0 100px; text-align:center;">
            <div style="
              height:20px;
              line-height:20px;
              margin-bottom:6px;
              font-size:14px;
            ">Waste</div>
            ${renderWaste()}
          </div>

          <div style="
            display:flex;
            align-items:flex-start;
            gap:8px;
            flex:0 0 auto;
            padding-top:26px;
            margin-left:20px;
          ">
            ${state.tableau.map((column, colIdx) =>
              renderColumn(column, colIdx)
            ).join("")}
          </div>
        </div>
      </div>
    </div>

    <div style="
      text-align:center;
      opacity:0.8;
      margin-top:18px;
      font-size:20px;
    ">
      Tip: click a face-up card (or waste), then click a column or foundation.
    </div>
  `;
}


  function renderStock() {
    if (state.stock.length === 0) {
      return `
        <div data-action="drawStock"
          style="width:100px; height:140px; border:1px dashed rgba(0,0,0,0.25); display:flex; align-items:center; justify-content:center; cursor:pointer; opacity:0.6;">
          empty
        </div>
      `;
    }
    // show back for stock (top card hidden)
    return `
      <img data-action="drawStock"
        src="${BASE_URL}200x280_back.png"
        style="width:100px; height:auto; cursor:pointer;"
      />
    `;
  }

  function renderWaste() {
    const wTop = top(state.waste);
    const isSelected = state.selected && state.selected.from === "waste";

    if (!wTop) {
      return `
        <div style="width:100px; height:140px; border:1px dashed rgba(0,0,0,0.25); opacity:0.3;"></div>
      `;
    }

    return renderCardImage(wTop, 100, {
      action: "selectWaste",
      extraStyle: isSelected ? "outline:3px solid rgba(0,0,0,0.35);" : ""
    });
  }

 function renderFoundation(suit) {
  const pile = state.foundations[suit];
  const fTop = top(pile);

  if (!fTop) {
    return `
      <div
        data-action="targetFoundation"
        data-suit="${suit}"
        style="
          box-sizing:border-box;
          width:70px;
          height:98px;
          border:1px dashed rgba(0,0,0,0.25);
          display:flex;
          align-items:center;
          justify-content:center;
          cursor:pointer;
          opacity:0.9;
        "
      >+</div>
    `;
  }

  return `
    <div
      data-action="targetFoundation"
      data-suit="${suit}"
      style="width:70px; height:98px; cursor:pointer;"
    >
      ${renderCardImage(fTop, 70, {
        extraStyle: "display:block; height:98px;"
      })}
    </div>
  `;
}


function renderColumn(column, colIdx) {

  const cardOffset = 30; // how much each card reveals
    const columnHeight =
        column.length === 0
            ? 140
            : 140 + (column.length - 1) * cardOffset;

  return `
 
    <div 
         data-action="targetTableau" 
        data-col="${colIdx}"
         style="
           position:relative;
              width:100px;
         height:${columnHeight}px;
  "
>


      ${
        column.length === 0
          ? `<div style="
              width:100px; 
              height:140px; 
              border:1px dashed rgba(0,0,0,0.25); 
              opacity:0.6;
            "></div>`
          : ""
      }

      ${column.map((card, idx) => {

        const sel = state.selected;
        const isSelected =
          sel &&
          sel.from === "tableau" &&
          sel.col === colIdx &&
          sel.index === idx;

        const topOffset = idx * cardOffset;

        if (!card.faceUp) {
          return `
            <div style="
              position:absolute;
              top:${topOffset}px;
              left:0;
            ">
              ${renderBack(card, 100)}
            </div>
          `;
        }

        return `
          <div style="
            position:absolute;
            top:${topOffset}px;
            left:0;
          ">
            ${renderCardImage(card, 100, {
              action: "selectTableau",
              data: `data-col="${colIdx}" data-idx="${idx}"`,
              extraStyle: isSelected
                ? "outline:3px solid rgba(0,0,0,0.35);"
                : ""
            })}
          </div>
        `;

      }).join("")}

    </div>
  `;
}

  function renderBack(card, width) {
    const rotation = card.rotation === 180 ? "rotate(180deg)" : "none";
    return `
      <img
        src="${BASE_URL}200x280_back.png"
        style="width:${width}px; height:auto; transform:${rotation};"
      />
    `;
  }

  function renderCardThumb(card) {
    // tiny previews for factory order
    const filename = card.type === "standard"
      ? `200x280_${card.suit}_${card.rank}.png`
      : `200x280_extra_${card.id}.png`;

    return `<img src="${BASE_URL}${filename}" style="width:80px; height:auto;" />`;
  }

  function renderCastingCard(card, suitEmoji) {
    const filename = `200x280_extra_${card.id}.png`;
    return `
      <div style="text-align:center;">
        <div style="font-size:28px; margin-bottom:10px;">
          <span class="suit-circle">${suitEmoji[card.suit]}</span>
        </div>
        <img src="${BASE_URL}${filename}" style="width:200px; height:auto;" />
      </div>
    `;
  }

  function renderCardImage(card, width, opts = {}) {
    const rotation = card.rotation === 180 ? "rotate(180deg)" : "none";

    let filename;
    if (card.type === "standard") filename = `200x280_${card.suit}_${card.rank}.png`;
    else filename = `200x280_extra_${card.id}.png`;

    const actionAttr = opts.action ? `data-action="${opts.action}"` : "";
    const extraData = opts.data ? opts.data : "";
    const extraStyle = opts.extraStyle ? opts.extraStyle : "";

    return `
      <img ${actionAttr} ${extraData}
        src="${BASE_URL}${filename}"
        style="width:${width}px; height:auto; transform:${rotation}; cursor:pointer; ${extraStyle}"
      />
    `;
  }

});

